export interface DomainInfo {
  subdomain: string
  baseDomain: string
  fullDomain: string
  isSimulated: boolean
}

/**
 * Checks for domain simulation parameter in URL
 * Used for testing domain-specific configurations in development
 *
 * Security Note: In production, this should log a warning if used
 */
export const getSimulatedDomain = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search)
  const simulatedDomain = urlParams.get('simulate_domain')

  // Warn in production if simulate_domain is used
  if (simulatedDomain !== null && process.env.NODE_ENV === 'production') {
    console.warn(
      'WARNING: simulate_domain parameter detected in production. ' +
      'This should only be used in development/staging environments.'
    )
  }

  return simulatedDomain
}

export const getDomainInfo = (): DomainInfo => {
  // Check for domain simulation first (for development/testing)
  const simulatedDomain = getSimulatedDomain()
  if (simulatedDomain !== null) {
    return {
      subdomain: simulatedDomain,
      baseDomain: 'dopa.ge',
      fullDomain: `${simulatedDomain}.dopa.ge`,
      isSimulated: true
    }
  }

  const hostname = window.location.hostname

  // Handle localhost
  if (hostname === 'localhost') {
    return {
      subdomain: 'studio', // Default for development
      baseDomain: 'dopa.ge',
      fullDomain: 'studio.dopa.ge',
      isSimulated: false
    }
  }

  const parts = hostname.split('.')

  return {
    subdomain: parts[0] ?? '',
    baseDomain: parts.slice(1).join('.'),
    fullDomain: hostname,
    isSimulated: false
  }
}

export const getCurrentDomain = (): string => {
  return getDomainInfo().subdomain
}





